import Select, { ValueContainerProps, components } from 'react-select';
import {
  NonScriptFiltersProps,
  ReactSelectOptionProp,
} from '../interface/interface';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ValueContainer = ({ children, ...props }: ValueContainerProps<any>) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let [values, input] = children as any;

  if (Array.isArray(values)) {
    const plural = values.length === 1 ? '' : 's';
    values = `${values.length} item${plural} selected`;
  }

  return (
    <components.ValueContainer {...props}>
      {values}
      {input}
    </components.ValueContainer>
  );
};

const NonScriptFilters = (props: NonScriptFiltersProps) => {
  const setAppliedFilters = (field: string, value: ReactSelectOptionProp[]) => {
    if (props?.setAppliedFilters) {
      props.setAppliedFilters((prev) => ({
        ...prev,
        [field]: value,
      }));
    }
  };

  return (
    <div className="flex flex-col lg:flex-row justify-end gap-5 mb-5 lg:mb-6">
      <div>
        <label className="block text-sm font-medium mb-2">Brand</label>
        <Select
          classNames={{
            control: (state) =>
              `${
                state.isFocused
                  ? 'border-grey-400 border text-sm'
                  : 'border-grey-400 border text-sm'
              } w-60 cursor-pointer lg:ml-2`,
          }}
          value={props.selectedBrand}
          options={props.brands ?? []}
          onChange={(selected) => {
            const value = [...selected];
            props.setSelectedBrand(value);
            localStorage.setItem('selectedBrand', JSON.stringify(value));
            setAppliedFilters('brand', value);
          }}
          isSearchable={false}
          isMulti
          isClearable
          hideSelectedOptions={false}
          components={{ ValueContainer }}
          isLoading={props.isBrandLoading}
          menuPortalTarget={document.body}
          menuPlacement="auto"
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          }}
          menuPosition="absolute"
          menuShouldBlockScroll={true}
          captureMenuScroll={true}
          menuShouldScrollIntoView={false}
        />
      </div>

      <div>
        <label className="block text-sm font-medium mb-2">Form</label>
        <Select
          classNames={{
            control: (state) =>
              `${
                state.isFocused
                  ? 'border-grey-400 border text-sm'
                  : 'border-grey-400 border text-sm'
              } w-60 cursor-pointer lg:ml-2`,
          }}
          value={props.selectedForm}
          options={props.formulation}
          onChange={(selected) => {
            props.setSelectedForm([...selected]);
            const value = [...selected];
            localStorage.setItem('selectedForm', JSON.stringify(value));
            setAppliedFilters('form', value);
          }}
          isSearchable={false}
          isMulti
          isClearable
          hideSelectedOptions={false}
          components={{ ValueContainer }}
          isLoading={props.isFormLoading}
          menuPortalTarget={document.body}
          menuPlacement="auto"
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          }}
          menuPosition="absolute"
          menuShouldBlockScroll={true}
          captureMenuScroll={true}
          menuShouldScrollIntoView={false}
        />
      </div>

      <div>
        <label className="block text-sm font-medium mb-2">Areas of Care</label>
        <Select
          classNames={{
            control: (state) =>
              `${
                state.isFocused
                  ? 'border-grey-400 border text-sm'
                  : 'border-grey-400 border text-sm'
              } w-60 cursor-pointer lg:ml-2`,
          }}
          value={props.selectedArea}
          options={props.conditions}
          onChange={(selected) => {
            props.setSelectedArea([...selected]);
            const value = [...selected];
            localStorage.setItem('selectedArea', JSON.stringify(value));
            setAppliedFilters('area', value);
          }}
          isSearchable={false}
          isMulti
          isClearable
          hideSelectedOptions={false}
          components={{ ValueContainer }}
          isLoading={props.isConditionLoading}
          menuPortalTarget={document.body}
          menuPlacement="auto"
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          }}
          menuPosition="absolute"
          menuShouldBlockScroll={true}
          captureMenuScroll={true}
          menuShouldScrollIntoView={false}
        />
      </div>
    </div>
  );
};

export default NonScriptFilters;
